(function () {
    'use strict';
    angular
        .module('app')
        .controller('gateKeeperController', gateKeeperController);
    gateKeeperController.$inject = ['$rootScope', '$scope', '$mdDialog', 'loginService', 'zcs', 'folderBrowserService', '$q', 'selectionCommandService', 'path', 'invalidItemsArray'];
    function gateKeeperController($rootScope, scope, $mdDialog, loginService, zcs, folderBrowserService, $q, selectionCommandService, path, invalidItemsArray) {
        
        scope.heading = loginService.resourceStrings["GATEKEEPER_TITLE"];
        scope.showInWindowsExplorerLabel = loginService.resourceStrings["SHOW_IN_WINDOWS_EXPLORER"];
        scope.closeLabel = loginService.resourceStrings["CLOSE"];

        scope.workAreaPath = path;

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: false,
            multiSelect: false,
            modifierKeysToMultiSelect: false,
            enableFullRowSelection: false,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Reason', field: 'reason', width: '15%', minWidth: '100' },
                { name: 'Name', field: 'name', width: '80%', minWidth: '100' }
            ],
            onRegisterApi: null
        }

        var colReason = loginService.resourceStrings["REASON"];
        var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
        scope.gridOptions.columnDefs[0].reason = colReason;
        scope.gridOptions.columnDefs[1].name = colName;

        selectionCommandService.GetMaxFilenameLength().then(function (data) {
            scope.maxFileNameLength = data;

            //Bill 04-20-2018 Title no longer has max len message
            //var maxMsg = loginService.resourceStrings["GATEKEEPER_MAX_PREFIX"];
            //maxMsg = maxMsg.replace("{0}", scope.maxFileNameLength);
            //scope.heading = scope.heading + " - " + maxMsg;

            scope.gridOptions.data = [];
            var index = 0;
            angular.forEach(invalidItemsArray, function (workAreaInvalidFile) {
                // Add item.
                if (workAreaInvalidFile.Reason > 0) {

                    var reasonMsg = loginService.resourceStrings["GATEKEEPER_REASON_TOOLONG"];
                    if (workAreaInvalidFile.Reason == 2)
                        reasonMsg = loginService.resourceStrings["GATEKEEPER_REASON_BADCHAR"];
                    else {
                        //Bill 04-20-2018 Added length display to Reason
                        reasonMsg = reasonMsg.replace("{0}", workAreaInvalidFile.Name.length);
                        reasonMsg = reasonMsg.replace("{1}", scope.maxFileNameLength.toString());
                    }

                    scope.gridOptions.data.push({
                        name: workAreaInvalidFile.Name,
                        reason: reasonMsg
                    });
                }
            });
        }, function (response) {
            selectionCommandService.ShowEx(response); // Nothing more to do.
        });

       

        scope.onWindowsExplorerClicked = function () {
            zcs.WindowsExplorer(scope.workAreaPath).then(function () {

            }, function (err) {
                //handled by http - $rootScope.msgBoxShow(err.data.ExceptionMessage, loginService.resourceStrings["SHOW_IN_WINDOWS_EXPLORER"]);
            });
        }

        scope.onGateKeeperClose = function () {
            // Close the dialog.
            $mdDialog.hide();
        }

    

        function activate() { }
        activate();
    }
})();
